import {
  AuditOutlined,
  BankOutlined,
  ContactsOutlined,
  FieldTimeOutlined,
  HomeFilled,
  HomeOutlined,
  MinusCircleFilled,
  MinusCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Typography,
  Select,
  Space,
} from "antd";
import { LoginImage } from "../../../assets";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../component/Logo/Logo";
import { UserContext } from "../../../context/User.context";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { LanguageContext } from "../../../context/Language.contex";
import TextArea from "antd/es/input/TextArea";

const { Title, Paragraph } = Typography;

var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };

export const VisitorComponent = () => {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { success, error } = Modal;

  const isMobile = useMediaQuery({ maxWidth: 768 }); // Deteksi perangkat mobile
  const { language } = useContext(LanguageContext);

  const [dataVisitorType, setVisitorType] = useState([]);
  const [dataVisitorTypeObj, setVisitorTypeObj] = useState([]);
  const [dataDepartment, setDepartment] = useState([]);
  const [typeGroup, settypeGroup] = useState("personal");
  const [withVehicle, setWithVehicle] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    getVisitorType();
    getDepartment();
  }, []);

  const getVisitorType = () => {
    setLoading(true);
    axios
      .get(
        `https://cmi-general-platform-be.vercel.app/visitor-type/lookup?limit=10`
      )
      .then((res) => {
        const { data } = res.data.data;

        setVisitorType(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getDepartment = () => {
    setLoading(true);
    axios
      .get(
        `https://cmi-general-platform-be.vercel.app/department/lookup?limit=20`
      )
      .then((res) => {
        const { data } = res.data.data;

        console.log(data);

        setDepartment(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const viewVisitorType = (code) => {
    setLoading(true);
    axios
      .get(`https://cmi-general-platform-be.vercel.app/visitor-type/${code}`)
      .then((res) => {
        const { data } = res.data;

        setVisitorTypeObj(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    // console.log(values);
    setLoading(true);

    try {
      axios
        .post(`https://cmi-general-platform-be.vercel.app/visitor`, values)
        .then((res) => {
          console.log(res.data);

          success({
            title: "Appoinment Berhasil!",
            content: "Selamat beraktivitas!",
            onOk: () => {
              navigate(`/visitor/${res.data.data.code}`);
            },
          });

          setLoading(false);
        })
        .catch((err) => {
          error({
            title: "Appoinment Gagal!",
            content: `${err.response.data.error_message}`,
          });
          setLoading(false);
        });
    } catch (err) {
      error({
        title: "Appoinment Gagal!",
        content: "Please try again!",
      });
      setLoading(false);
    }
  };

  const handleGroupTypeChange = (e) => {
    settypeGroup(e.target.value);
  };
  //   DROPDOWN
  const handleChange = (value) => {
    console.log(`selected ${value}`);

    viewVisitorType(value);
  };
  return (
    <>
      <Row
        justify="space-around"
        style={{ marginTop: isMobile ? 20 : 70 }}
        align="middle"
      >
        {/* Gambar Untuk Tampilan Mobile*/}

        {/* Form */}
        <Col xl={8} lg={10} md={10} sm={12}>
          <Card
            bodyStyle={{
              boxShadow: "0px 0px 47px 0px rgba(0,0,0,0.1)",
            }}
            bordered={false}
          >
            {isMobile && (
              <Col xl={9} lg={10} md={10} sm={12}>
                <img
                  src={LoginImage}
                  alt="Login Illustration"
                  style={{
                    width: "90%",
                    margin: "0 auto",
                    // display: "block",
                    objectFit: "cover",
                  }}
                />
              </Col>
            )}
            <Link to="/" className="menuItem">
              <Logo />
            </Link>
            <Title level={3}> {language[4]}</Title>
            <Divider />
            <Form
              form={form}
              layout="vertical"
              autoComplete="off"
              onFinish={onFinish}
              initialValues={{
                is_vehicle: withVehicle,
                visitor_group: typeGroup,
              }}
            >
              <Form.Item
                label={
                  <span>
                    {language[5]}{" "}
                    <span
                      style={{
                        color: "red",
                        fontSize: "12px",
                        // fontWeight: "normal",
                        animation: "blink 1s infinite",
                      }}
                    >
                      {language[17]}
                    </span>
                  </span>
                }
                hasFeedback
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Nama diperlukan!",
                  },
                  { whitespace: true },
                ]}
              >
                <Input
                  allowClear
                  size="large"
                  placeholder={`${language[13]} ${language[5]}`}
                  prefix={<UserOutlined className="site-form-item-icon" />}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span>
                    {language[18]}{" "}
                    <span
                      style={{
                        color: "red",
                        fontSize: "12px",
                        // fontWeight: "normal",
                        // animation: "blink 1s infinite",
                      }}
                    >
                      <i>{language[32]}</i>
                    </span>
                  </span>
                }
                hasFeedback
                name="id_number"
                rules={[
                  {
                    required: true,
                    message: "Number id diperlukan!",
                  },
                  { min: 3 },
                  { whitespace: true },
                ]}
              >
                <Input
                  allowClear
                  size="large"
                  placeholder={`${language[13]} ${language[18]}`}
                  prefix={<UserOutlined className="site-form-item-icon" />}
                />
              </Form.Item>

              <Row align="middle" style={{ marginBottom: 10, marginLeft: 2 }}>
                <Col flex="none">
                  <Form.Item
                    valuePropName="checked"
                    name="is_vehicle"
                    style={{ marginBottom: 0 }}
                  >
                    <Checkbox
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setWithVehicle(isChecked);

                        // Reset nilai form jika checkbox tidak dicentang
                        if (!isChecked) {
                          form.setFieldsValue({
                            fleet_number: null,
                            type_vehicle: null,
                          });
                        }
                      }}
                      style={{ alignItems: "center" }}
                    >
                      {language[49]}
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>

              {withVehicle && (
                <>
                  <Row
                    align="middle"
                    style={{ marginBottom: 0, width: "100%" }} // Ubah width menjadi 100%
                  >
                    <Col flex="auto" style={{ paddingRight: 8 }}>
                      {" "}
                      {/* Tambahkan padding untuk jarak */}
                      <Form.Item
                        label={language[50]}
                        name="fleet_number"
                        rules={[
                          {
                            required: true,
                            message: "fleet number required!",
                          },
                          { whitespace: true },
                        ]}
                      >
                        <Input
                          placeholder={`${language[13]} ${language[50]}`}
                          style={{ width: "100%" }} // Ubah width input menjadi 100%
                        />
                      </Form.Item>
                    </Col>
                    <Col flex="auto" style={{ paddingLeft: 8 }}>
                      {" "}
                      {/* Tambahkan padding untuk jarak */}
                      <Form.Item
                        label={language[51]}
                        name="type_vehicle"
                        rules={[
                          {
                            required: true,
                            message: "Container Number required!",
                          },
                          // {
                          //   whitespace: true,
                          //   message: "Input cannot be empty or only spaces!",
                          // },
                          // {
                          //   pattern: /^[A-Za-z0-9]+$/, // Hanya huruf dan angka yang diperbolehkan
                          //   message: "Only letters and numbers are allowed!",
                          // },
                        ]}
                      >
                        <Input
                          placeholder={`${language[13]} ${language[51]}`}
                          style={{ width: "100%" }} // Ubah width input menjadi 100%
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}

              <Form.Item
                label={<span>{language[6]}</span>}
                hasFeedback
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Alamat diperlukan!",
                  },
                  { whitespace: true },
                ]}
              >
                <Input
                  allowClear
                  size="large"
                  placeholder={`${language[13]} ${language[6]}`}
                  prefix={<HomeOutlined className="site-form-item-icon" />}
                />
              </Form.Item>

              <Form.Item
                label={<span>{language[7]}</span>}
                hasFeedback
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "Nomor telepon diperlukan!",
                  },
                  { whitespace: true },
                  { min: 6 },
                ]}
              >
                <Input
                  allowClear
                  size="large"
                  type="number"
                  placeholder={`${language[13]} ${language[7]}`}
                  prefix={<ContactsOutlined className="site-form-item-icon" />}
                />
              </Form.Item>

              <Form.Item
                label={<span>{language[8]}</span>}
                hasFeedback
                name="institution"
                rules={[
                  {
                    required: true,
                    message: "Nama institusi diperlukan!",
                  },
                  { whitespace: true },
                ]}
              >
                <Input
                  allowClear
                  size="large"
                  placeholder={`${language[13]} ${language[8]}`}
                  prefix={<BankOutlined className="site-form-item-icon" />}
                />
              </Form.Item>

              <Form.Item
                label={<span>{language[10]}</span>}
                hasFeedback
                name="appointment"
                rules={[
                  {
                    required: true,
                    message: "janji temu diperlukan!",
                  },
                  { whitespace: true },
                ]}
              >
                <Input
                  allowClear
                  size="large"
                  placeholder={`${language[13]} ${language[10]}`}
                  prefix={<AuditOutlined className="site-form-item-icon" />}
                />
              </Form.Item>
              <Form.Item
                label={<span>{language[21]}</span>}
                hasFeedback
                name="department_id"
                rules={[
                  {
                    required: true,
                    message: "department required!",
                  },
                  { whitespace: true },
                ]}
              >
                <Select
                  disabled={loading}
                  placeholder={`${language[13]} ${language[21]}`}
                  menuItemSelectedIcon={<HomeFilled />}
                  onChange={(val) => {}}
                  options={dataDepartment.map((el) => ({
                    value: `${el.id}`,
                    label: el.name,
                  }))}
                />
              </Form.Item>

              <Form.Item
                label={<span>{language[19]}</span>}
                hasFeedback
                name="visitor_type_id"
                rules={[
                  {
                    required: true,
                    message: "tipe pengunjung diperlukan!",
                  },
                  { whitespace: true },
                ]}
              >
                <Select
                  disabled={loading}
                  placeholder={`${language[13]}${language[19]}`}
                  menuItemSelectedIcon={<FieldTimeOutlined />}
                  onChange={handleChange}
                  options={dataVisitorType.map((el) => {
                    let modifiedName = el.name;
                    if (el.name === "Kontraktor") {
                      modifiedName = ` ${language[33]}`;
                    } else if (el.name === "Intership") {
                      modifiedName = ` ${language[36]}`;
                    } else if (el.name === "Visitor") {
                      modifiedName = ` ${language[35]}`;
                    } else if (el.name === "Interview") {
                      modifiedName = ` ${language[34]} / Induction`;
                    }
                    // pastikan value adalah string id, fallback ke code jika id tidak ada
                    return {
                      value: el.id ? String(el.id) : el.code,
                      label: modifiedName,
                    };
                  })}
                />
              </Form.Item>
              <Form.Item
                label={<span>{language[20]}</span>}
                hasFeedback
                name="visit_time"
                rules={[
                  {
                    required: true,
                    message: "waktu diperlukan!",
                  },
                  { whitespace: true },
                ]}
              >
                <Select
                  //   defaultValue="lucy"
                  //   style={{ alignItems: "start" }}
                  disabled={loading}
                  placeholder={`${language[13]} ${language[20]}`}
                  menuItemSelectedIcon={<FieldTimeOutlined />}
                  options={dataVisitorTypeObj.visit_time?.map((el) => {
                    let modifiedName = el;

                    if (el === "1 Hari") {
                      modifiedName = ` ${language[43]}`;
                    } else if (el === "3 Hari") {
                      modifiedName = ` ${language[44]}`;
                    } else if (el === "5 Hari") {
                      modifiedName = ` ${language[45]}`;
                    } else if (el === "1 Bulan") {
                      modifiedName = ` ${language[46]}`;
                    } else if (el === "3 Bulan") {
                      modifiedName = ` ${language[47]}`;
                    } else if (el === "6 Bulan") {
                      modifiedName = ` ${language[48]}`;
                    }
                    return {
                      value: el, // Nilai yang akan dikirim saat dipilih
                      label: modifiedName, // Label yang ditampilkan pada dropdown
                    };
                  })}
                />
              </Form.Item>

              <Form.Item
                label={<span>{language[9]}</span>}
                hasFeedback
                name="description"
                rules={[
                  {
                    required: true,
                    message: "Tujuan diperlukan!",
                  },
                  { whitespace: true },
                ]}
              >
                <TextArea
                  allowClear
                  size="large"
                  placeholder={`${language[13]} ${language[9]}`}
                  prefix={<AuditOutlined className="site-form-item-icon" />}
                />
              </Form.Item>

              <Form.Item
                label={<span>Visitor Group</span>}
                hasFeedback
                name="visitor_group"
                rules={[
                  { required: true, message: "Pilih group!" },
                  { whitespace: true },
                ]}
              >
                <Radio.Group
                  value={typeGroup}
                  onChange={handleGroupTypeChange}
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Radio.Button
                    value="group"
                    style={{ flex: 1, textAlign: "center" }}
                  >
                    Group
                  </Radio.Button>
                  <Radio.Button
                    value="personal"
                    style={{ flex: 1, textAlign: "center" }}
                  >
                    Personal
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>

              <br />
              {typeGroup == "group" ? (
                <Space>
                  <Form.List name="visitor_list">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map((_a) => {
                          var { key, name } = _a,
                            restField = __rest(_a, ["key", "name"]);
                          return (
                            <Space
                              key={key}
                              style={{ display: "flex", marginBottom: 8 }}
                              align="baseline"
                            >
                              <Form.Item
                                {...restField}
                                name={[name, "name"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Missing name",
                                  },
                                ]}
                              >
                                <Input placeholder="Name" />
                              </Form.Item>
                              <Form.Item
                                {...restField}
                                name={[name, "nik"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Missing nik",
                                  },
                                ]}
                              >
                                <Input placeholder="Nik" />
                              </Form.Item>
                              <MinusCircleOutlined
                                onClick={() => remove(name)}
                              />
                            </Space>
                          );
                        })}
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusCircleOutlined />}
                          >
                            Add Visitor List
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>
                </Space>
              ) : (
                <></>
              )}
              {/* <Form.Item
                label={<span>{language[21]}</span>}
                hasFeedback
                name="department_id"
                rules={[
                  {
                    required: true,
                    message: "department required!",
                  },
                  { whitespace: true },
                ]}
              >
                
              </Form.Item> */}

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  size="large"
                  block
                  loading={loading}
                >
                  {language[11]}
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>

        {/* Gambar untuk Mobile */}
        {!isMobile && (
          <Col xl={9} lg={10} md={10} sm={12}>
            <img
              src={LoginImage}
              alt=""
              style={{
                width: "90%",
              }}
            />
          </Col>
        )}
      </Row>
    </>
  );
};
